import { API_ENDPOINT } from ".";

export const sendEmail = async (obj: any) => {
  try {
    const response = await fetch(`${API_ENDPOINT}/send-email/webridge`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    });
    return response.status;
  } catch (err) {
    console.log(err);
  }
};

export const sendEmailPure = async (obj: any) => {
  try {
    const response = await fetch(`${API_ENDPOINT}/send-email-pure`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj),
    });
    return response.status;
  } catch (err) {
    console.log(err);
  }
};
